import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const cycleTimeReportEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-cycle-time-report-entrypoint" */ './src/ui'),
	),
	getPreloadProps: () => ({}),
});
